import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig";
import { doc, updateDoc, getDoc, setDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ProgressBar from "../components/ProgressBar"; // 追加
import "../styles/CompleteProfile.css";

const CompleteProfile2 = () => {
  const [user] = useAuthState(auth);
  const [profile, setProfile] = useState({
    name: "",
    location: "",
    height: "",
    figure: "",
    income: "",
    works: "",
    educationc: "",
    holiday: "",
    cohabitant: "",
    contact: "",
    tobacco: "",
    alcohol: "",
  });
  
  const [error, setError] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const navigate = useNavigate();

  const heightOptions = Array.from({ length: 70 }, (_, i) => ({ value: i + 140, label: `${i + 140} cm` }));

  const figureOptions = [
    { value: '普通', label: '普通' },
    { value: '細身', label: '細身' },
    { value: '筋肉質', label: '筋肉質' },
    { value: 'がっしり', label: 'がっしり' },
    { value: 'ぽっちゃり', label: 'ぽっちゃり' },
    { value: 'ふくよか', label: 'ふくよか' },
    { value: 'その他', label: 'その他' }
  ];
  
  const incomeOptions = [
    { value: '200万円未満', label: '200万円未満' },
    { value: '200〜400万円', label: '200〜400万円' },
    { value: '400〜600万円', label: '400〜600万円' },
    { value: '600〜800万円', label: '600〜800万円' },
    { value: '800〜1000万円', label: '800〜1000万円' },
    { value: '1000万円以上', label: '1000万円以上' }
  ];
  
  const occupationOptions = [
    { value: '学生', label: '学生' },
    { value: '会社員', label: '会社員' },
    { value: '公務員', label: '公務員' },
    { value: '教員', label: '教員' },
    { value: '医師', label: '医師' },
    { value: '看護師', label: '看護師' },
    { value: '弁護士', label: '弁護士' },
    { value: 'エンジニア', label: 'エンジニア' },
    { value: 'デザイナー', label: 'デザイナー' },
    { value: 'クリエイター', label: 'クリエイター' },
    { value: '営業職', label: '営業職' },
    { value: '経営者', label: '経営者' },
    { value: 'フリーランス', label: 'フリーランス' },
    { value: '自営業', label: '自営業' },
    { value: '研究職', label: '研究職' },
    { value: 'その他', label: 'その他' }
  ];
  
  const educationOptions = [
    { value: '中学卒', label: '中学卒' },
    { value: '高校卒', label: '高校卒' },
    { value: '専門学校卒', label: '専門学校卒' },
    { value: '短大卒', label: '短大卒' },
    { value: '大学卒', label: '大学卒' },
    { value: '大学院卒', label: '大学院卒' },
    { value: 'その他', label: 'その他' }
  ];
  
  const holidayOptions = [
    { value: '土日', label: '土日' },
    { value: '平日', label: '平日' },
    { value: '不定期', label: '不定期' },
    { value: 'その他', label: 'その他' }
  ];
  
  const cohabitantOptions = [
    { value: '一人暮らし', label: '一人暮らし' },
    { value: '家族と同居', label: '家族と同居' },
    { value: '友達と同居', label: '友達と同居' },
    { value: 'ペットと同居', label: 'ペットと同居' },
    { value: 'その他', label: 'その他' }
  ];
  
  const contactFrequencyOptions = [
    { value: '毎日', label: '毎日' },
    { value: '週数回', label: '週数回' },
    { value: '週1回', label: '週1回' },
    { value: '月数回', label: '月数回' },
    { value: 'あまり連絡しない', label: 'あまり連絡しない' }
  ];
  
  const tobaccoOptions = [
    { value: '吸う', label: '吸う' },
    { value: '時々吸う', label: '時々吸う' },
    { value: '吸わない', label: '吸わない' }
  ];
  
  const alcoholOptions = [
    { value: '飲む', label: '飲む' },
    { value: '時々飲む', label: '時々飲む' },
    { value: '飲まない', label: '飲まない' }
  ];
  


  useEffect(() => {
    if (user) {
      user.reload().then(() => {
        setEmailVerified(user.emailVerified);
      });

      const fetchProfile = async () => {
        try {
          const docRef = doc(db, "members", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setProfile({
              height: data.height || "",
              figure: data.figure || "",
              income: data.income || "",
              works: data.works || "",
              educationc: data.educationc || "",
              holiday: data.holiday || "",
              cohabitant: data.cohabitant || "",
              contact: data.contact || "",
              tobacco: data.tobacco || "",
              alcohol: data.alcohol || "",
            });
          }
        } catch (error) {
          console.error("Error fetching profile:", error.message);
          setError("プロフィールの取得中にエラーが発生しました。");
        }
      };
      fetchProfile();
    }
  }, [user]);

  const handleSave = async () => {
    if (!emailVerified) {
      setError("メールアドレスの認証が完了していません。メールを確認してください。");
      return;
    }
  
    const { height, figure, income, works, educationc, holiday, cohabitant, contact, tobacco, alcohol } = profile;
  
  
    try {
      const userDocRef = doc(db, "members", user.uid);
      const docSnap = await getDoc(userDocRef);
  
      // **空の値でもFirestoreに保存**
      const profileData = {
        height: height || "",
        figure: figure || "",
        income: income || "",
        works: works || "",
        educationc: educationc || "",
        holiday: holiday || "",
        cohabitant: cohabitant || "",
        contact: contact || "",
        tobacco: tobacco || "",
        alcohol: alcohol || "",
      };
  
      if (docSnap.exists()) {
        await updateDoc(userDocRef, profileData);
      } else {
        await setDoc(userDocRef, profileData);
      }
  
      navigate("/complete-profile3"); // 次のページへ
    } catch (error) {
      console.error("Error saving profile:", error.message);
      setError("プロフィールの保存中にエラーが発生しました。");
    }
  };
  
  

  return (
    <div className="complete-profile-container">
      <ProgressBar step={2} totalSteps={6} /> {/* 進捗バーを追加 */}

      <h2>詳細プロフィールを入力(任意)</h2>
      {error && <p className="error-message">{error}</p>}

      {emailVerified ? (
        <>

<div className="form-group-a">
  <label>身長:</label>
  <Select
    name="height"
    isSearchable={false}
    value={profile.height ? { value: profile.height, label: profile.height } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, height: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...heightOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>体型:</label>
  <Select
    name="figure"
    isSearchable={false}
    value={profile.figure ? { value: profile.figure, label: profile.figure } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, figure: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...figureOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>収入:</label>
  <Select
    name="income"
    isSearchable={false}
    value={profile.income ? { value: profile.income, label: profile.income } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, income: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...incomeOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>職業:</label>
  <Select
    name="works"
    isSearchable={false}
    value={profile.works ? { value: profile.works, label: profile.works } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, works: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...occupationOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>学歴:</label>
  <Select
    name="educationc"
    isSearchable={false}
    value={profile.educationc ? { value: profile.educationc, label: profile.educationc } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, educationc: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...educationOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>休日:</label>
  <Select
    name="holiday"
    isSearchable={false}
    value={profile.holiday ? { value: profile.holiday, label: profile.holiday } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, holiday: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...holidayOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>同居人:</label>
  <Select
    name="cohabitant"
    isSearchable={false}
    value={profile.cohabitant ? { value: profile.cohabitant, label: profile.cohabitant } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, cohabitant: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...cohabitantOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>連絡頻度:</label>
  <Select
    name="contact"
    isSearchable={false}
    value={profile.contact ? { value: profile.contact, label: profile.contact } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, contact: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...contactFrequencyOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>タバコ:</label>
  <Select
    name="tobacco"
    isSearchable={false}
    value={profile.tobacco ? { value: profile.tobacco, label: profile.tobacco } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, tobacco: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...tobaccoOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>アルコール:</label>
  <Select
    name="alcohol"
    isSearchable={false}
    value={profile.alcohol ? { value: profile.alcohol, label: profile.alcohol } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, alcohol: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...alcoholOptions]}
    className="select-box"
  />
</div>



          <button onClick={handleSave} className="complete-profile-button">次へ</button>
        </>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default CompleteProfile2;
